<template>
    <div v-if="!statsLoading && AllowedToShowStatistics(subscription)" class="page-block__item-wrapper">
        <h3>{{ trans('hosting.statistics-title') }}</h3>

        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.bandwidth') }}
                    </span>
                    </div>
                    <div class="layout__item u-2/3-desk">
                        {{ bandwidth }} MB
                    </div>
                </div>
            </div>
        </div>

        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.disk-usage') }}
                    </span>
                    </div>
                    <div class="layout__item u-2/3-desk">
                        {{ quota }} MB
                    </div>
                </div>
            </div>
        </div>

        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.numbers-of-domains') }}
                    </span>
                    </div>
                    <div class="layout__item u-2/3-desk">
                        {{ n_domains }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import HostingApi from '../services/api/hosting.js';
import {EventBus} from "relapp-event/src/event";

export default {
    mixins: [apiMixin],
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            bandwidth: '',
            quota: '',
            n_domains: 0,
            statsLoading: true,
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted(){
        if(this.AllowedToShowStatistics(this.subscription)){
            this.showUserStatistics();
        }
    },
    methods: {
        showUserStatistics() {
            HostingApi.showUserStatistics(this.domain)
                .then(response => {
                    this.bandwidth = response.data.bandwidth;
                    this.n_domains = response.data.n_domains;
                    this.quota = response.data.quota;
                    this.statsLoading = false;
                })
                .catch(function (result) {
                    if (result.data.message === "IntegratedService does not support user statistics retrieval yet!") {
                        EventBus.$emit('notification', {
                            type: 'error',
                            message: result.data.message
                        });
                    }
                });
        },

        /**
         * Check if hosting provider is directadmin
         */
        AllowedToShowStatistics(subscription) {
            return subscription.hosting_provider === "directadmin";
        }
    }
};
</script>
